import { broadcast } from '@finn-no/common-browserbundle';
import { collectWhenLoaded } from '@finn-no/navigation-timing';
import tracking from '@finn-no/analytics';
import pulse from '@finn-no/pulse-sdk';
import cookieMatch from '@finn-no/distribution-cookiematch';
import controllerist from './controllerist';

function trackExternal(eventDetail) {
    return (e) => {
        e.preventDefault();
        if (window.finnAnalytics) {
            window.finnAnalytics.trackExitLink({
                analyticsName: `navigation.partner-clicked.${eventDetail}`,
                stringValue: 'frontpage',
            });
        }
        window.location.href = e.currentTarget.href;
    };
}

function performanceController() {
    const { host } = window.location;
    if (
        host.indexOf('dev.finn.no') === -1 &&
        host.indexOf('local.finn.no') === -1
    ) {
        collectWhenLoaded(
            'frontpage-podium',
            'https://www.finn.no/clientstats.html',
        );
    }
}

function main() {
    const c = controllerist();
    c.register('performance-timing', performanceController);

    c.run(document);

    cookieMatch({ source: 'frontpage' });
    setTimeout(() => {
        broadcast();
    }, 0);

    if (navigator.serviceWorker) {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    window.addEventListener('DOMContentLoaded', () => {
        // The new Pulse tracking implementation.
        pulse.setState({
            vertical: {
                name: 'common_pages',
            },
        });
        pulse.trackPageView({
            object: {
                type: 'Frontpage',
            },
        });

        // Adobe and "legacy" Pulse page view tracking via finn-analytics-js.
        // Should be removed when Innsikt has switched to the new Pulse implementation.
        tracking.trackPage({
            context: {
                contentType: 'Frontpage',
            },
        });

        const styletimeLink = document.querySelector(`[data-styletime-link]`);
        if (styletimeLink) {
            styletimeLink.addEventListener('click', trackExternal('styletime'));
        }

        const mittanbudLink = document.querySelector(`[data-mittanbud-link]`);
        if (mittanbudLink) {
            mittanbudLink.addEventListener(
                'click',
                trackExternal('mitt-anbud'),
            );
        }

        const moteplassenLink = document.querySelector(
            `[data-moteplassen-link]`,
        );
        if (moteplassenLink) {
            moteplassenLink.addEventListener(
                'click',
                trackExternal('moeteplassen'),
            );
        }
    });
}

main();
